// Cache jQuery elements
const $stickyBar = $(".js-sticky-bar");
const $window = $(window);
const $footer = $("#footercontent");
const $backToTop = $(".back-to-top", $footer);
const backToTopBottomCss = $backToTop.css("bottom");
let position = $window.scrollTop();

/**
* Handles the sticky bar on scroll
* Set the position of the back to top button
* And add the sticky class to the sticky bar
*/
export const handleStickyBar = () => {
    const scrollPosition = $window.scrollTop();
    const stickyIt = scrollPosition > position && !$footer.isInViewport();
    const newBackToTopBottomCss = stickyIt ? $stickyBar.outerHeight(true) + 15 : backToTopBottomCss;

    $stickyBar.toggleClass("is-sticky", stickyIt);
    $backToTop.css("bottom", newBackToTopBottomCss);
    position = scrollPosition;
};

/**
* Handles the sticky bar on scroll
* @returns {undefined}
*/
export default () => {
    if ($stickyBar || $stickyBar.length) {
        $window.on("scroll", $window[0].debounce(handleStickyBar, 100));
    }
};
